import React, { forwardRef } from "react"

function StepProgress({ activeStep, formStepsCount }, ref) {
  return (
    <div ref={ref} className="step-progress Form__Element displaymode-full">
      {Array.from({ length: formStepsCount }, (_, i) => i + 1).map((step) => {
        const actualActiveStep = activeStep + 1
        const isActive = step === actualActiveStep
        const isCompleted = step < actualActiveStep

        const nextStep = step + 1
        const isLineSolid = step <= actualActiveStep && nextStep <= actualActiveStep

        return (
          <div className="step" key={step}>
            <div className={["circle", isActive ? "active" : "", isCompleted ? "completed" : ""].join(" ")}>{step}</div>
            {step !== formStepsCount && <div className={isLineSolid ? "step-line line-completed" : "step-line line-incomplete"} />}
          </div>
        )
      })}
    </div>
  )
}

export default forwardRef(StepProgress)
